<div
  class="leg-description"
  [ngClass]="{
    'leg-description--dim': !legChecked || legDescription.valueChanged
  }"
>
  <ng-container *ngFor="let item of legDescription.description; let i = index">
    <ng-container *ngIf="item.title">
      <span class="leg-description__title">{{ item.title }}</span>
    </ng-container>

    <ng-container *ngIf="item.text">
      <span class="leg-description__text">{{ item.text }}</span>
    </ng-container>

    <ng-container *ngIf="item.headers && item.rows">
      <div class="leg-description__table-container">
        <table ui-table class="table-data">
          <thead>
            <tr>
              <th
                class="table-data__header"
                *ngFor="let header of item.headers"
              >
                <div class="table-data__header__container">
                  {{ header }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr tabindex="0" *ngFor="let row of item.rows">
              <td *ngFor="let data of row; let i = index">
                {{ data | scheduleFormat: null:null }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>

  <div class="leg-description__footer">
    <button
      class="ui-button primary"
      (click)="onCopyToClipboardClicked()"
      type="button"
    >
      Copy to clipboard
    </button>
    &nbsp;
    <button class="ui-button primary" (click)="hideDescription()" type="button">
      Close
    </button>
  </div>
</div>
